module.exports = "/fonts/opensansitalic.ttf";